import isEqual from 'lodash-es/isEqual'
import * as Yup from 'yup'

import { EMPTY_OBJECT } from '../../../constants/common'
import { getItemsIds } from '../../../utils/common'
import {
  EntityActionTypeSelectOptionValue,
  getEntityActionTypeSelectOptions,
} from '../../Entity'
import { formValidationSchemaNoChanged } from '../../Form'
import { FORMIK_ENTITY_ACTION_CONFIG_FIELDS_TYPE_SELECT_NAME } from '../../Formik'

import {
  ITEM_ACTION_TYPES,
  USER_EDIT_ADDRESS_FORM_MODAL_FIELD_NAME_ADDED_FLATS,
  USER_EDIT_ADDRESS_FORM_MODAL_FIELD_NAME_BUILDING,
  USER_EDIT_ADDRESS_FORM_MODAL_FIELD_NAME_SELECTED_FLATS,
  USER_EDIT_ADDRESS_FORM_MODAL_REQUIRED_FLATS_FIELD_WHEN_BUILDING_SELECTED,
} from './UserEditAddressFormModal.constants'

function isEqualFormValuesExceptBuilding({ initialValues, values }) {
  const initialFormValues = { ...initialValues }
  const currentFormValues = { ...values }

  delete initialFormValues[USER_EDIT_ADDRESS_FORM_MODAL_FIELD_NAME_BUILDING]

  delete currentFormValues[USER_EDIT_ADDRESS_FORM_MODAL_FIELD_NAME_BUILDING]

  return isEqual(initialFormValues, currentFormValues)
}

export function getUserEditAddressFormModalSaveConfirmCondition(
  values,
  permissions
) {
  return (
    values[USER_EDIT_ADDRESS_FORM_MODAL_FIELD_NAME_ADDED_FLATS].length === 0 &&
    permissions.can_manage_all_user_flats
  )
}

export function getUserEditAddressFormModalSubmitPayload(values) {
  return getItemsIds(
    values[USER_EDIT_ADDRESS_FORM_MODAL_FIELD_NAME_ADDED_FLATS],
    'value'
  )
}

export function getUserEditAddressFormModalItemActionTypes(
  availableTypes = ITEM_ACTION_TYPES
) {
  return Object.values(getEntityActionTypeSelectOptions()).filter(item =>
    availableTypes.includes(item.value)
  )
}

export function getUserEditAddressFormModalInitialValues(values) {
  const actionTypeOptions = getEntityActionTypeSelectOptions()

  return {
    ...values,
    [FORMIK_ENTITY_ACTION_CONFIG_FIELDS_TYPE_SELECT_NAME]:
      actionTypeOptions[EntityActionTypeSelectOptionValue.Edit],
  }
}

export function getUserEditAddressFormModalValidationSchema({ initialValues }) {
  return Yup.object({
    [USER_EDIT_ADDRESS_FORM_MODAL_FIELD_NAME_BUILDING]: Yup.mixed().nullable(),
    [USER_EDIT_ADDRESS_FORM_MODAL_FIELD_NAME_SELECTED_FLATS]: Yup.array().test(
      USER_EDIT_ADDRESS_FORM_MODAL_REQUIRED_FLATS_FIELD_WHEN_BUILDING_SELECTED,
      true,
      function () {
        const parent = this.parent || EMPTY_OBJECT

        const building =
          parent[USER_EDIT_ADDRESS_FORM_MODAL_FIELD_NAME_BUILDING]
        const addedFlats =
          parent[USER_EDIT_ADDRESS_FORM_MODAL_FIELD_NAME_ADDED_FLATS]

        if (!building) {
          return true
        }

        return Array.isArray(addedFlats) && addedFlats.length > 0
      }
    ),
  }).concat(
    formValidationSchemaNoChanged({
      initialValues,
      isEqual: isEqualFormValuesExceptBuilding,
    })
  )
}
